module.exports = __webpack_public_path__ + "img/desktop_lancamento1.9632fd15.webp";